export function VideoIcon({ className }: { className?: string }) {
    return (
      <svg 
        className={className} 
        width="41" 
        height="36" 
        viewBox="0 0 41 36" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M0 9C0 6.51797 2.04288 4.5 4.55556 4.5H22.7778C25.2905 4.5 27.3333 6.51797 27.3333 9V27C27.3333 29.482 25.2905 31.5 22.7778 31.5H4.55556C2.04288 31.5 0 29.482 0 27V9ZM39.797 7.01719C40.5373 7.41094 41 8.17031 41 9V27C41 27.8297 40.5373 28.5891 39.797 28.9828C39.0568 29.3766 38.1599 29.3344 37.4552 28.8703L30.6219 24.3703L29.6111 23.7023V22.5V13.5V12.2977L30.6219 11.6297L37.4552 7.12969C38.1528 6.67266 39.0496 6.62344 39.797 7.01719Z" 
          fill="#00C950" 
        />
      </svg>
    )
  }